var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meta-edit-tabs empty-meta-wrapper"},[_c('div',{staticClass:"empty-meta-placeholder"},[_c('img',{staticClass:"empty-meta-img",attrs:{"src":"/static/metaTab/no-book.png"}})])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9d1241a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/NoBookSelected.vue
// module id = 1063
// module chunks = 6